export default __webpack_public_path__ + "static/media/redMedium.2f7f4cae.svg";